<div class="order-filter">
  <h3 class="order-filter-title">{{ 'order.filters.title' | translate }}</h3>

  <div class="order-filter-container">
    <cx-select-field
      bindValue="id"
      bindLabel="name"
      [label]="'order.filters.brand' | translate"
      [placeholder]="'order.filters.brandPlaceholder' | translate"
    />
    <cx-multi-select-field
      bindValue="id"
      bindLabel="name"
      [label]="'order.filters.status' | translate"
      [placeholder]="'order.filters.statusPlaceholder' | translate"
    />
    <cx-calendar-field
      bindValue="id"
      bindLabel="name"
      [label]="'order.filters.date' | translate"
      [placeholder]="'order.filters.datePlaceholder' | translate"
    />
  </div>
</div>
